import React, { useState, useEffect } from "react";
import { inventoryColumns, inventoryRows } from "../../../constants/bussiness";
import BasicCustomTable from "../../../component/basicTable";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";
import { useSelector } from "react-redux";
import CustomPopupForm from "../../../component/customPopupModel";
import { formatServiceType } from "../../../utils/customerHealperFunctions";
import { categoryValueToLabel } from "../../../constants/campaignConstants";

const DIALOG_TYPES = {
  CREATE: "inventory",
  DELETE: "delete",
};

export default function InventoryManagement() {
  const showSnackbar = useSnackbar();
  const [inventoryData, setInventoryData] = useState([]);
  const { loginDetails } = useSelector((state) => state.counter);
  const storeId = loginDetails.storeId || null;
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [mode, setMode] = useState("create");
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchInvetory(page, rowsPerPage);
  }, []);

  const fetchInvetory = (pageNumber, limit ) => {
    axiosInstance
      .get(
        `/customer/store/inventory/${storeId}?page=${
          pageNumber 
        }&limit=${limit}`
      )
      .then((res) => {
        const formattedUser = res?.data?.inventory?.map((item) => ({
          id: item?.id || "",
          name: item?.itemName || "",
          sku: item?.skuCode || "",
          itemQuantity: item?.itemQuantity || "",
          itemDescription: item?.itemDescription,
          pricePerQuantity: item?.pricePerQuantity,
          price: "$" + item?.pricePerQuantity,
          category: item?.category,
          applicableCategory: item?.applicableCategory,
          category_name: categoryValueToLabel(item?.category),
          service:
            item?.applicableCategory?.length > 0
              ? item?.applicableCategory
                  .map((cat) => formatServiceType(cat))
                  .join(", ")
              : formatServiceType(item?.applicableCategory || ""),
          itemImage: item?.itemImage,
        }));
        setInventoryData(formattedUser);
        setPage(res?.data?.currentPage || 0);
        setTotalCount(res?.data?.total || 0);
      })
      .catch((err) => {
        console.log(err);
        showSnackbar("Something went wrong!", "error");
      });
  };

  const handlePageChangeRequest = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
    fetchInvetory(newPage, newRowsPerPage);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setDialogType("");
  };

  const handleAddInventory = () => {
    setMode("create");
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleEdit = (row) => {
    setMode("edit");
    setSelectedRow(row);
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setDialogType(DIALOG_TYPES.DELETE);
    setOpenDialog(true);
  };

  const handleDeleteConfirm = async (id) => {
    try {
      await axiosInstance.delete(`/customer/store/inventory/delete/${id}`);
      fetchInvetory(page, rowsPerPage);
      handleCloseDialog();

    } catch (error) {
      showSnackbar("Something went wrong!", "error");
    }
  };

  const handleSubmit = (service) => {
    handleCloseDialog();
    fetchInvetory(page, rowsPerPage);
  };

  return (
    <div>
      <div className="flex justify-between items-center w-full mb-2 pl-8 pr-6">
        <h2 className="text-2xl font-semibold">Inventory Management</h2>
        <CustomButton
          onClick={() => handleAddInventory()}
          customeClass="gradient-button w-[140px] h-[45px] mr-1"
        >
          + Add Item
        </CustomButton>
      </div>
      <div className="pb-3 pl-8 pr-6 h-[calc(100vh-150px)]">
        <BasicCustomTable
          columns={inventoryColumns}
          rows={inventoryData}
          colorHeader={true}
          customClassHeader={"table-header-cell-colored"}
          tableName="permission"
          onEdit={handleEdit}
          onDelete={handleDelete}
          maxHeightClass="max-h-[calc(100vh-230px)]"
          backendPagination={true}
          totalCount={totalCount}
          onPageChangeRequest={handlePageChangeRequest}
          pageLimit={rowsPerPage}
          page={page}
          // totalPages={totalPages}
        />
      </div>
      {dialogType === DIALOG_TYPES.CREATE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.CREATE}
          mode={mode}
          dialogDetails={selectedRow}
          onSubmit={handleSubmit}
        />
      )}

      {dialogType === DIALOG_TYPES.DELETE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.DELETE}
          onDelete={handleDeleteConfirm}
          dialogDetails={{
            title: "Delete Confirmation",
            content: "Are you sure you want to delete service record?",
            rowData: selectedRow,
          }}
        />
      )}
    </div>
  );
}
